var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 33,
    viewBox: "0 0 61 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.74414,
    y1: 10.35,
    x2: 59.4318,
    y2: 10.35,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 26.6646,
    y1: 10.5,
    x2: 26.6646,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6.54941,
    y1: 10.5,
    x2: 6.54941,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 7.46348,
    y1: 10.5,
    x2: 7.46348,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 8.37754,
    y1: 10.5,
    x2: 8.37754,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 9.29258,
    y1: 10.5,
    x2: 9.29258,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 10.2066,
    y1: 10.5,
    x2: 10.2066,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 11.1207,
    y1: 10.5,
    x2: 11.1207,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 12.0357,
    y1: 10.5,
    x2: 12.0357,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 12.9498,
    y1: 10.5,
    x2: 12.9498,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 13.8648,
    y1: 10.5,
    x2: 13.8648,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 14.7789,
    y1: 10.5,
    x2: 14.7789,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 15.6939,
    y1: 10.5,
    x2: 15.6939,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 16.608,
    y1: 10.5,
    x2: 16.608,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 17.5221,
    y1: 10.5,
    x2: 17.5221,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 18.4361,
    y1: 10.5,
    x2: 18.4361,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 19.3502,
    y1: 10.5,
    x2: 19.3502,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 20.2652,
    y1: 10.5,
    x2: 20.2652,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 21.1803,
    y1: 10.5,
    x2: 21.1803,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 22.0934,
    y1: 10.5,
    x2: 22.0934,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 23.0074,
    y1: 10.5,
    x2: 23.0074,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 23.9225,
    y1: 10.5,
    x2: 23.9225,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 24.8375,
    y1: 10.5,
    x2: 24.8375,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 25.7506,
    y1: 10.5,
    x2: 25.7506,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 27.5807,
    y1: 10.5,
    x2: 27.5807,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 28.4947,
    y1: 10.5,
    x2: 28.4947,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 29.4088,
    y1: 10.5,
    x2: 29.4088,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 30.3229,
    y1: 10.5,
    x2: 30.3229,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 31.2389,
    y1: 10.5,
    x2: 31.2389,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 32.152,
    y1: 10.5,
    x2: 32.152,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 33.066,
    y1: 10.5,
    x2: 33.066,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 33.9801,
    y1: 10.5,
    x2: 33.9801,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 34.8961,
    y1: 10.5,
    x2: 34.8961,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 35.8092,
    y1: 10.5,
    x2: 35.8092,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 36.7223,
    y1: 10.5,
    x2: 36.7223,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 37.6373,
    y1: 10.5,
    x2: 37.6373,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 38.5523,
    y1: 10.5,
    x2: 38.5523,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 39.4664,
    y1: 10.5,
    x2: 39.4664,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 40.3805,
    y1: 10.5,
    x2: 40.3805,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 41.2955,
    y1: 10.5,
    x2: 41.2955,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 42.2096,
    y1: 10.5,
    x2: 42.2096,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 43.1236,
    y1: 10.5,
    x2: 43.1236,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 44.0377,
    y1: 10.5,
    x2: 44.0377,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 44.9527,
    y1: 10.5,
    x2: 44.9527,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 45.8668,
    y1: 10.5,
    x2: 45.8668,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 46.7799,
    y1: 10.5,
    x2: 46.7799,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 47.6949,
    y1: 10.5,
    x2: 47.6949,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 56.8385,
    y1: 10.5,
    x2: 56.8385,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 57.7516,
    y1: 10.5,
    x2: 57.7516,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 58.6666,
    y1: 10.5,
    x2: 58.6666,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 48.61,
    y1: 10.5,
    x2: 48.61,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 49.524,
    y1: 10.5,
    x2: 49.524,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 50.4381,
    y1: 10.5,
    x2: 50.4381,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 51.3531,
    y1: 10.5,
    x2: 51.3531,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 52.2672,
    y1: 10.5,
    x2: 52.2672,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 53.1813,
    y1: 10.5,
    x2: 53.1813,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 54.0953,
    y1: 10.5,
    x2: 54.0953,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 55.0104,
    y1: 10.5,
    x2: 55.0104,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 55.9244,
    y1: 10.5,
    x2: 55.9244,
    y2: 15.9858,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 2.74414,
    y1: 11.2641,
    x2: 59.4318,
    y2: 11.2641,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 2.74414,
    y1: 12.1801,
    x2: 59.4318,
    y2: 12.1801,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 2.74316,
    y1: 13.0941,
    x2: 59.4308,
    y2: 13.0941,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 2.74316,
    y1: 14.0082,
    x2: 59.4308,
    y2: 14.0082,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 2.74316,
    y1: 14.9223,
    x2: 59.4308,
    y2: 14.9223,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 2.74414,
    y1: 15.8363,
    x2: 59.4318,
    y2: 15.8363,
    stroke: "#C3C3C3",
    strokeWidth: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.771 24.8752C48.771 23.8985 49.4856 23.1035 50.3694 23.1035C51.2532 23.1035 51.9678 23.8985 51.9678 24.8752V30.6767C51.9678 31.6534 51.2532 32.4441 50.3694 32.4441C49.4856 32.4441 48.771 31.6534 48.771 30.6767V24.8752Z",
    fill: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.771 18.6389C48.771 17.6621 49.4856 16.8672 50.3694 16.8672C51.2532 16.8672 51.9678 17.6621 51.9678 18.6389V24.4403C51.9678 25.4171 51.2532 26.2078 50.3694 26.2078C49.4856 26.2078 48.771 25.4171 48.771 24.4403V18.6389Z",
    fill: "#434343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1769 12.0889C53.6547 12.5498 54.1325 13.0149 54.6061 13.4758C55.2531 14.1016 56.0015 13.6619 56.6231 13.2982C57.4392 12.8204 58.6866 12.3468 59.4985 11.869C60.1412 11.4927 60.6275 10.5962 59.9679 9.95774C59.2786 9.28965 58.6063 9.6533 57.9171 10.055C57.2912 10.4229 56.2341 10.7907 55.6041 11.1544C54.8514 10.4271 54.0987 9.69558 53.346 8.96406C53.2911 8.90909 53.2319 8.85412 53.1727 8.79492V12.0889H53.1769Z",
    fill: "#868686"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4444 16.0449C57.3487 16.0389 57.259 16.021 57.1663 16.0001C56.2544 15.7638 55.0345 15.2135 54.1226 14.9772C53.9282 14.9264 53.7189 14.8725 53.5216 14.8007C53.5097 14.7948 53.4947 14.7918 53.4827 14.7858C53.4558 14.7768 53.4319 14.7648 53.408 14.7589C53.396 14.7529 53.3871 14.7499 53.3781 14.7469C53.3452 14.7319 53.3153 14.72 53.2884 14.705C53.2854 14.702 53.2824 14.6991 53.2764 14.6991C52.9416 14.5376 52.6725 14.2983 52.5948 13.8917C52.5828 13.8259 52.5769 13.7542 52.5739 13.6794C52.565 13.0126 52.5561 12.3519 52.5442 11.6881L51.5484 12.6837L51.5811 14.8813C51.593 15.1504 51.7126 15.3896 51.895 15.56C52.0146 15.6796 52.1641 15.7694 52.3405 15.8142L56.2333 17.0584C56.7566 17.193 57.2858 16.8791 57.4204 16.3559C57.4474 16.2512 57.4563 16.1526 57.4474 16.0479L57.4444 16.0449Z",
    fill: "#434343"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3418 18.2341C53.3418 18.8853 52.9316 19.4096 52.4242 19.4096H48.8596C48.3522 19.4096 47.942 18.881 47.942 18.2341V9.1091C47.942 8.45792 48.3522 7.93359 48.8596 7.93359H52.4242C52.9316 7.93359 53.3418 8.46215 53.3418 9.1091V18.2341Z",
    fill: "#868686"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7949 4.08856C53.7949 5.90256 52.3234 7.37406 50.5051 7.37406C48.6869 7.37406 47.2196 5.90256 47.2196 4.08856C47.2196 2.27456 48.6911 0.798828 50.5051 0.798828C52.3192 0.798828 53.7949 2.27033 53.7949 4.08856Z",
    fill: "#868686"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7095 24.8752C49.7095 23.8985 50.4283 23.1035 51.3079 23.1035C52.1916 23.1035 52.9062 23.8985 52.9062 24.8752V30.6767C52.9062 31.6534 52.1916 32.4441 51.3079 32.4441C50.4241 32.4441 49.7095 31.6534 49.7095 30.6767V24.8752Z",
    fill: "#868686"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7095 18.6389C49.7095 17.6621 50.4283 16.8672 51.3079 16.8672C52.1916 16.8672 52.9062 17.6621 52.9062 18.6389V24.4403C52.9062 25.4171 52.1916 26.2078 51.3079 26.2078C50.4241 26.2078 49.7095 25.4171 49.7095 24.4403V18.6389Z",
    fill: "#868686"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4464 2.59564H53.4992C53.051 1.33979 51.8543 0.443359 50.4462 0.443359C48.6702 0.443359 47.2325 1.86835 47.1987 3.63583H53.6937H54.4506C54.7381 3.63583 54.9707 3.40327 54.9707 3.11574C54.9707 2.8282 54.7381 2.59564 54.4506 2.59564H54.4464Z",
    fill: "#C3C3C3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57083 24.8752C1.57083 23.8985 2.28544 23.1035 3.1692 23.1035C4.05296 23.1035 4.76758 23.8985 4.76758 24.8752V30.6767C4.76758 31.6534 4.05296 32.4441 3.1692 32.4441C2.28544 32.4441 1.57083 31.6534 1.57083 30.6767V24.8752Z",
    fill: "#434343"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57083 18.6389C1.57083 17.6621 2.28544 16.8672 3.1692 16.8672C4.05296 16.8672 4.76758 17.6621 4.76758 18.6389V24.4403C4.76758 25.4171 4.05296 26.2078 3.1692 26.2078C2.28544 26.2078 1.57083 25.4171 1.57083 24.4403V18.6389Z",
    fill: "#434343"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9767 12.0889C6.45452 12.5498 6.93234 13.0149 7.40594 13.4758C8.0529 14.1016 8.80134 13.6619 9.42293 13.2982C10.239 12.8204 11.4864 12.3468 12.2983 11.869C12.9411 11.4927 13.4273 10.5962 12.7677 9.95774C12.0784 9.28965 11.4061 9.6533 10.7169 10.055C10.091 10.4229 9.03391 10.7907 8.40386 11.1544C7.65119 10.4271 6.89852 9.69558 6.14584 8.96406C6.09087 8.90909 6.03167 8.85412 5.97247 8.79492V12.0889H5.9767Z",
    fill: "#868686"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2452 16.0449C10.1495 16.0389 10.0598 16.021 9.9671 16.0001C9.05517 15.7638 7.8353 15.2135 6.92337 14.9772C6.72902 14.9264 6.51973 14.8725 6.3224 14.8007C6.31044 14.7948 6.29549 14.7918 6.28353 14.7858C6.25662 14.7768 6.2327 14.7648 6.20878 14.7589C6.19682 14.7529 6.18785 14.7499 6.17888 14.7469C6.14599 14.7319 6.11609 14.72 6.08919 14.705C6.0862 14.702 6.08321 14.6991 6.07723 14.6991C5.74236 14.5376 5.47328 14.2983 5.39558 13.8917C5.38363 13.8259 5.37765 13.7542 5.37467 13.6794C5.36576 13.0126 5.35686 12.3519 5.34496 11.6881L4.34919 12.6837L4.38187 14.8813C4.39381 15.1504 4.51339 15.3896 4.69576 15.56C4.81535 15.6796 4.96484 15.7694 5.14125 15.8142L9.03412 17.0584C9.55736 17.193 10.0866 16.8791 10.2212 16.3559C10.2481 16.2512 10.2571 16.1526 10.2482 16.0479L10.2452 16.0449Z",
    fill: "#434343"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14258 18.2341C6.14258 18.8853 5.73241 19.4096 5.22499 19.4096H1.66036C1.15294 19.4096 0.742775 18.881 0.742775 18.2341V9.1091C0.742775 8.45792 1.15294 7.93359 1.66036 7.93359H5.22499C5.73241 7.93359 6.14258 8.46215 6.14258 9.1091V18.2341Z",
    fill: "#868686"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59473 4.08856C6.59473 5.90256 5.12321 7.37406 3.30495 7.37406C1.48669 7.37406 0.0193987 5.90256 0.0193987 4.08856C0.0193987 2.27456 1.49092 0.798828 3.30495 0.798828C5.11898 0.798828 6.59473 2.27033 6.59473 4.08856Z",
    fill: "#868686"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5093 24.8752C2.5093 23.8985 3.22815 23.1035 4.10768 23.1035C4.99144 23.1035 5.70605 23.8985 5.70605 24.8752V30.6767C5.70605 31.6534 4.99144 32.4441 4.10768 32.4441C3.22392 32.4441 2.5093 31.6534 2.5093 30.6767V24.8752Z",
    fill: "#868686"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5093 18.6389C2.5093 17.6621 3.22815 16.8672 4.10768 16.8672C4.99144 16.8672 5.70605 17.6621 5.70605 18.6389V24.4403C5.70605 25.4171 4.99144 26.2078 4.10768 26.2078C3.22392 26.2078 2.5093 25.4171 2.5093 24.4403V18.6389Z",
    fill: "#868686"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24617 2.59564H6.29899C5.85077 1.33979 4.6541 0.443359 3.24601 0.443359C1.47003 0.443359 0.0323396 1.86835 -0.00148869 3.63583H6.4935H7.2504C7.53794 3.63583 7.77051 3.40327 7.77051 3.11574C7.77051 2.8282 7.53794 2.59564 7.2504 2.59564H7.24617Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD6);
export default __webpack_public_path__ + "static/media/d6.ac811c22e3cd0f81a3e3e02d6612fe48.svg";
export { ForwardRef as ReactComponent };